export const CONSTS = {
    border: {
        radius: "8px",
        radius2: "12px"
    },
    colors:{
        primary: "#473cd5",//6357FF
        primaryDark: "#232374",
        primaryLight: "rgba(99,87,255,.15)",

        error: "#C63535",
        errorDark: "#A81C1C",
        errorLight: "rgba(198,53,53,.15)",

        success: "#35C635",
        successDark: "#1BA31B",
        successLight: "rgba(53,198,53,.15)",

        warning: "#C6A935",
        warningDark: "#9E8216",
        warningLight: "rgba(198,169,53,.15)",

        info: "#727987",
        infoDark: "#3C4454",
        infoLight: "rgba(114,121,135,.15)",

        greyDarker: '#727987',
        greyDark: '#B1B9C7',
        grey: '#EEF2FB',
        greyLight: '#DDE2EB',
        greyLighter: '#EEF2FB',
        secondary: '#4E1F81'
    },
    fonts: {
        primary: {
            regular: 'dana',
            thin: 'dana',
            extraLight: 'dana',
            light: 'dana',
            medium: 'dana',
            bold: 'dana',
            extraBold: 'dana',
        }
    },
    responsiveSizes: {
        extraSmall: '575.98px',
        small: '767.98px',
        medium: '991.98px',
        large: '1199.98px',
    }
}